import * as React from 'react';
import ReactModal from 'react-modal';
import { NavLink } from 'react-router-dom';

import { DataOverview} from './DataOverview';
import { DataProcessingStep } from './DataProcessingStep';
import { uploadFile, downloadDupesCSV, downloadDupesCSV_b, downloadFixSpending, downloadAbvExpansion, downloadTruncation, doneAction, proceed,cancel } from '../../actions/SubmissionActions';
import { UploadAction, UploadState } from '../../interface/SubmissionInterface';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { ApplicationState } from '../../reducers/Index';
import { downloadFile } from '../../actions/SpendingReportActions';

interface FileState {
    file ?: any
    file2 ?: any
}

class Upload extends React.Component<UploadAction & UploadState, FileState> {
    constructor(props) {
        super(props);
        this.state = {
            file: null
        }
        this.onChange = this.onChange.bind(this)
        this.onChangeFile2 = this.onChangeFile2.bind(this)

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleSubmit2 = this.handleSubmit2.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleProceed = this.handleProceed.bind(this);
    }
    handleProceed() {
        this.props.proceed(this.props.UserState.display_id, this.props.fileType, this.state.file.name);
    }

    handleCancel() {
        var result = confirm("Are you sure you want to cancel?");
        if (result) {
            //this.props.cancel(this.props.UserState.display_id, this.props.SubmissionState.SubmissionID, (this.state.file == null) ? "bad state" : this.state.file.name, this.props.fileType)
            this.props.cancel(this.props.UserState.display_id, this.props.SubmissionState.SubmissionID, (this.state.file == null) ? "bad state" : this.props.SubmissionState.FileNameStamped, this.props.fileType)
        }
    }

    handleSubmit(msg) {
        if (this.state.file !== undefined && this.state.file !== null) {
            this.props.uploadFile(this.props.UserState, this.state.file, this.props.fileType, msg);
        }
    }

    handleSubmit2(msg) {
        //console.log('here');
        //console.log(this.state.file2);
        if (this.state.file2 !== undefined && this.state.file2 !== null) {
            this.props.uploadFile(this.props.UserState, this.state.file2, this.props.fileType, msg);
        }
    }

    onChange(e) {
        this.setState({ file: e.target.files[0] })
    }

    onChangeFile2(e) {
        this.setState({ file2: e.target.files[0] })
    }

    render() {

        var fileName = 'Award.csv';
        if (this.props.fileType == "vendor")
            fileName = "Vendor.csv";
        else if (this.props.fileType == "award")
            fileName = "Award.csv";
        else if (this.props.fileType == "employee")
            fileName = "Employee.csv";
        else if (this.props.fileType == "empname")
            fileName = "EmployeeName.csv";
        else if (this.props.fileType == "objcode")
            fileName = "ObjectCodes.csv";
        else if (this.props.fileType == "suborg")
            fileName = "OrgUnits.csv";
        else if (this.props.fileType == "subaward")
            fileName = "Subaward.csv";
        else if (this.props.fileType == "awardidentity")
            fileName = "AwardIdentity.csv";
        else if (this.props.fileType == "coinvestigator")
            fileName = "AwardCoInvestigators.csv";
        //console.log(this.props);
        const response = { file: '../../dist/downloads/sample/' + fileName }
        //console.log(response);

        var today = new Date(),
            date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();

        // if all steps are complete, call post processing
        if (this.props.SubmissionState) {
            if (this.props.fileType == "vendor" || this.props.fileType == "subaward") {
                if (this.props.SubmissionState.StepsCompleted == 5 && this.props.SubmissionState.fileStatus != "processing complete" && this.props.SubmissionState.fileStatus != "upload confirmed" && this.props.SubmissionState.fileStatus != "upload cancelled") {
                    this.props.doneAction(this.props.fileType, this.props.UserState.display_id, this.props.SubmissionState.SubmissionID);
                }
            }
            else if (this.props.fileType == "awardidentity") {
                if (this.props.SubmissionState.StepsCompleted == 3 && this.props.SubmissionState.fileStatus != "processing complete" && this.props.SubmissionState.fileStatus != "upload confirmed" && this.props.SubmissionState.fileStatus != "upload cancelled") {
                    this.props.doneAction(this.props.fileType, this.props.UserState.display_id, this.props.SubmissionState.SubmissionID);
                }
            }
            else {
                if (this.props.SubmissionState.StepsCompleted == 2 && this.props.SubmissionState.fileStatus != "processing complete" && this.props.SubmissionState.fileStatus != "upload confirmed" && this.props.SubmissionState.fileStatus != "upload cancelled") {
                    this.props.doneAction(this.props.fileType, this.props.UserState.display_id, this.props.SubmissionState.SubmissionID);
                }
            }
        }

        var buttonsDisabled = true;
        var uploadButtonShow = true;
        if (this.props.SubmissionState.fileStatus == "processing complete")
            buttonsDisabled = false;

        if (this.props.SubmissionState.fileStatus == "upload confirmed" || this.props.SubmissionState.fileStatus == "upload cancelled")
            uploadButtonShow = false;

        return <div className='UploadModal container-fluid'>
            <div className='row'>
                <div className='col-md-12'>
                    <h2>IRIS Data Upload</h2>
                    <i className="fa fa-arrow-circle-left bluelink"></i><NavLink to={'/submissions'}> Go back to File upload list</NavLink>
                </div>
            </div>
            {
                (this.props.SubmissionState.fileStatus.startsWith("mismatch")) &&
                <div style={{ paddingTop: "30px" }}>
                    <div className='row'>
                        <div className='col-md-12'>
                            <h6>Your upload file format has columns that do not match expected columns.</h6>
                            <p style={{ paddingBottom: "10px" }}>{this.props.SubmissionState.fileStatus.replace("mismatch", "")}</p>
                            <p style={{ paddingBottom: "10px" }}>Please contact <strong>irisdatateam@umich.edu</strong></p>

                            <p><button className="btn-primary filterButton" type="button" onClick={() => this.handleSubmit(this.props.SubmissionState.fileStatus)}>Continue upload with these column names</button>
                            </p>

                            <p style={{ paddingTop: "20px", paddingBottom: "20px", fontWeight: "bold" }}>OR</p>
                            <p>Fix column headings and re-upload</p>
                            <p>See sample {this.props.fileType} file: <a href={response.file}><i className="fa fas fa-download"></i>here</a></p>

                        </div>
                    </div>
                </div>
            }

            <div className='row'>
                <div className='details col-md-8'>
                    <fieldset><span>File Type: </span><span className="purple">{this.props.fileType}</span></fieldset>
                    <fieldset><span>Submission Date: </span><span className="purple">{date}</span></fieldset>
                    <fieldset><span>See sample {this.props.fileType} data file: </span><span className="purple"><a href={response.file}><i className="fa fas fa-download"></i>here</a></span></fieldset>
                    {!this.props.SubmissionState.fileStatus.startsWith("mismatch") && uploadButtonShow && <fieldset><input type="file" onChange={this.onChange} /> <button className="btn-primary filterButton uploadButton" type="button" onClick={() => this.handleSubmit("")}>Upload</button></fieldset>}
                    {this.props.SubmissionState.fileStatus.startsWith("mismatch") && uploadButtonShow && <fieldset><input type="file" onChange={this.onChangeFile2} /> <button className={`${(this.state.file2 !== undefined) ? "btn-primary" : ""} filterButton uploadButton`} type="button" onClick={() => this.handleSubmit2("")}>Upload</button></fieldset>}
                </div>
                <div className='middleAlign col-md-3'>
                    <span>Upload Progress: {this.props.SubmissionState.fileStatus.startsWith("mismatch") ? "column mismatch error" : this.props.SubmissionState.fileStatus}</span>
                </div>
            </div>
            {
                (this.props.SubmissionState.fileStatus == "upload complete" || this.props.SubmissionState.fileStatus == "processing started" || this.props.SubmissionState.fileStatus == "processing complete") &&
                <div>
                    <div className="row">
                        <div className='details col-md-12'>
                            <h3 className="confirm_heading">Confirm data upload?</h3>
                            <div className="button_section">
                                <span className="button"><input className={buttonsDisabled && "gray"} onClick={this.handleProceed} disabled={buttonsDisabled} id="proceed" type="submit" value="Yes, Proceed!" name="proceed" /></span>
                                <span className="button"><input className={buttonsDisabled && "gray"} onClick={this.handleCancel} disabled={buttonsDisabled} id="cancel" type="submit" value="Cancel" name="cancel" /></span>
                            </div>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-md-12'>
                            <h3>Important details about your data upload</h3>
                        </div>
                    </div>

                    <div className='row'>
                        <div className='details col-md-12'>
                            <h5>Data Overview - Before Processing</h5>
                            <DataOverview FileSummaryOutput_Pre={this.props.SubmissionState && this.props.SubmissionState.FileSummaryOutput_Pre} pre_or_post={'pre'} />
                        </div>
                        <div className='details col-md-12'>
                            <h5>Data Overview - After Processing</h5>
                            <DataOverview FileSummaryOutput_Post={this.props.SubmissionState && this.props.SubmissionState.FileSummaryOutput_Post} pre_or_post={'post'} />
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-md-12'>
                            <h6>Data Processing Steps</h6>
                        </div>
                    </div>

                    <div className='row'>
                        <div className='details col-md-12'>
                            <div className="section"><span>1</span><span>Data Clean-up</span></div>
                            <DataProcessingStep
                                step={"dupes"}
                                UserState={this.props.UserState}
                                SubmissionState={this.props.SubmissionState}
                                fileType={this.props.fileType}
                                downloadCSVFile={this.props.downloadDupesCSV}
                                heading={"Data Step 1a: Removing Duplicates from within file.."}
                                tooltip={"This step removes duplicates from the uploaded file. Duplicates are defined as two or more records that contain the same value in every submitted field. When duplicates are found, one record is kept while the other records are removed. Note that vendor and subaward transactions that are submitted at the daily level are never considered duplicates, as it is unclear whether they are duplicates or distinct transactions."}
                                DupesSummaryOutput={this.props.SubmissionState && this.props.SubmissionState.DupesSummaryOutput}
                            />
                            <DataProcessingStep
                                step={"dupes_b"}
                                UserState={this.props.UserState}
                                SubmissionState={this.props.SubmissionState}
                                fileType={this.props.fileType}
                                downloadCSVFile={this.props.downloadDupesCSV_b}
                                heading={"Data Step 1b: Removing Duplicates from recent submissions.."}
                                tooltip={"This step removes duplicates from all files submitted since the last submission deadline. Duplicates are defined as two or more records that contain the same value in every submitted field. When duplicates are found, the record from the most recent submission is kept. A high percentage of file duplication may indicate overlapping submissions or a re-upload. Note that vendor and subaward transactions that are submitted at the daily level are never considered duplicates, as it is unclear whether they are duplicates or distinct transactions."}
                                DupesSummaryOutput_b={this.props.SubmissionState && this.props.SubmissionState.DupesSummaryOutput_b}
                            />
                            {(this.props.fileType == "vendor" || this.props.fileType == "subaward") &&
                                <DataProcessingStep
                                    step={"abv"}
                                    UserState={this.props.UserState}
                                    SubmissionState={this.props.SubmissionState}
                                    fileType={this.props.fileType}
                                    downloadCSVFile={this.props.downloadAbvExpansion}
                                    heading={"Data Step 2: Expanding Abbreviations..."}
                                    tooltip={"This step converts abbreviations commonly seen in the OrgName field into their unabbreviated form. This is done to improve our ability to match OrgNames to Census data."}
                                    AbvOutput={this.props.SubmissionState && this.props.SubmissionState.AbvOutput}
                                    csvData={this.props.SubmissionState && this.props.SubmissionState.AbvOutput && this.props.SubmissionState && this.props.SubmissionState.AbvOutput.abvCSVOutput}
                                />}
                            {(this.props.fileType == "vendor" || this.props.fileType == "subaward" || this.props.fileType == "awardidentity") &&
                                <DataProcessingStep
                                    step={"fix_spending"}
                                    UserState={this.props.UserState}
                                    SubmissionState={this.props.SubmissionState}
                                    fileType={this.props.fileType}
                                    downloadCSVFile={this.props.downloadFixSpending}
                                    heading={"Data Step 3: Fixing Spending.."}
                                    tooltip={"This step attempts to clean submitted payment values so that they are able to be ingested as a numeric value in our database."}
                                    FixSpendingOutput={this.props.SubmissionState && this.props.SubmissionState.FixSpendingOutput}
                                    csvData={this.props.SubmissionState && this.props.SubmissionState.FixSpendingOutput && this.props.SubmissionState.FixSpendingOutput.fixSpendingCSVOutput}
                                />}
                        </div>
                        {(this.props.fileType == "vendor" || this.props.fileType == "subaward") &&
                            <div className='details col-md-12'>
                                <div className="section"><span>2</span><span>Data Issues Detection</span></div>
                                <DataProcessingStep
                                    step={"truncation"}
                                    UserState={this.props.UserState}
                                    SubmissionState={this.props.SubmissionState}
                                    fileType={this.props.fileType}
                                    downloadCSVFile={this.props.downloadTruncation}
                                    heading={"Data Step 4: Detecting Truncation.."}
                                    tooltip={"This step finds rows that are likely to be truncated in the OrgName or Address fields. Many distinct vendors with the same length name or address may cause false positives in this step. Results should be manually reviewed to determine the full extent of truncation. If the truncation is legitimate, cancelling the submission and pulling more complete data can drastically improve our ability to match to Census data."}
                                    TruncationOutput={this.props.SubmissionState && this.props.SubmissionState.TruncationOutput}
                                    csvData={this.props.SubmissionState && this.props.SubmissionState.TruncationOutput && this.props.SubmissionState.TruncationOutput.truncationCSVOutput}
                                />
                            </div>
                        }
                    </div>
                </div>
            }
            {
                (this.props.SubmissionState.fileStatus == "upload confirmed") &&
                <div>
                    <div className='row'>
                        <div className='col-md-12'>
                            <h3>Thank you for submitting your data upload.</h3>
                            <i className="fa fa-arrow-circle-left bluelink"></i><NavLink to={'/submissions'}> Go back to File upload list</NavLink>
                        </div>
                    </div>
                </div>
            }
            {
                (this.props.SubmissionState.fileStatus == "upload cancelled") &&
                <div>
                    <div className='row'>
                        <div className='col-md-12'>
                            <h3>Your data upload was cancelled.</h3>
                            <i className="fa fa-arrow-circle-left bluelink"></i><NavLink to={'/submissions'}> Go back to File upload list</NavLink>
                        </div>
                    </div>
                </div>
            }
            {
                (this.props.SubmissionState.fileStatus == "incorrect file format") &&
                <div>
                    <div className='row'>
                        <div className='col-md-12'>
                            <h6>Your upload file format does not match the expected file type. Please see sample {this.props.fileType} file.</h6>
                            <u><a href={response.file}>Download Sample file here</a></u>

                            <div className="marginTop">
                                <i className="fa fa-arrow-circle-left bluelink"></i><NavLink to={'/submissions'}> Go back to File upload list</NavLink>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>

    }
}
function matchDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            uploadFile: uploadFile,
            downloadDupesCSV: downloadDupesCSV,
            downloadDupesCSV_b: downloadDupesCSV_b,
            downloadFixSpending: downloadFixSpending,
            downloadAbvExpansion: downloadAbvExpansion,
            downloadTruncation: downloadTruncation,
            doneAction: doneAction,
            proceed: proceed,
            cancel: cancel
        }, dispatch
    )
}

const mapStateToProps = (state: ApplicationState) => ({
    UserState: state.userProperties,
    SubmissionState: state.submissionProperties,
});


export default connect(
    mapStateToProps, // Selects which state properties are merged into the component's props
    matchDispatchToProps
)(Upload);

